<div class="sso-page">
  <div class="sso-panel">
    <div class="sso-logo">
      <img src="assets/site_logo_white.svg" alt="GioSite" />
    </div>
    @if (loading) {
    <div class="sso-status sso-status--loading">
      <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
    </div>
    } @if (error) {
    <div class="sso-status sso-status--error">
      <h4>Error al decodificar el token de acceso</h4>
    </div>
    }
  </div>
</div>
<div class="sso-background bg-maindark"></div>
